<template>
  <div style="width: 100%;height: 800px;" id="swagger_page">
    <iframe :src="url" frameBorder="0" width="100%" height="800px"></iframe>
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
export default {
  data () {
    return {
      url:'',
      //管理员相关信息
      AdminInfor:{
        id:'',
        name:'',
        photo:'',
        type:'',
      },
    }
  },
  //页面开启时执行
  mounted(){
    this.onePage();
  },
  //方法
  methods: {
    onePage(){
      let head=window.location.href;
      let heads=head.split(":")
      let one=heads[0]+"://";
      let two=window.location.host;
      let url=one+two+"/api/swagger-ui.html";
      this.url=url;
      //console.log(one+two+"/api/swagger-ui.html")
    },
    //获取信息方法
    judgeLogin(){
      this.AdminInfor.id=this.$store.state.a_id;
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/admin/views/swagger/Swagger.vue